import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { produceOn } from 'app/_state/produce-on';

export const PrintButtonStateName = 'PrintButtonState';

export interface PrintButtonState {
  enabled: boolean;
  entityIds: string[];
  campaignId: string;
  additionalParams?: Record<string, any>;
}

export const PRINT_BUTTON_INITIAL_STATE: PrintButtonState = {
  enabled: false,
  entityIds: null,
  campaignId: null,
  additionalParams: {}
};

// Selectors
export const SELECT_PRINT_BUTTON_STATE = createSelector(createFeatureSelector<PrintButtonState>(PrintButtonStateName), s => s);

// Actions
export const SET_PRINT_BUTTON_STATE = createAction(
  '[Print] SET_PRINT_BUTTON_STATE', props<{
    enabled: boolean;
    campaignId: string;
    entityIds: string[];
    additionalParams?: Record<string, any>;
  }>()
);

// Reducers
const _printButtonReducers = createReducer(PRINT_BUTTON_INITIAL_STATE,
  produceOn(SET_PRINT_BUTTON_STATE, (state, payload) => {
    state.enabled = payload.enabled;
    state.entityIds = payload.entityIds;
    state.campaignId = payload.campaignId;
    state.additionalParams = payload.additionalParams || {};
  })
);

export function printButtonReducers(state, action) {
  return _printButtonReducers(state, action);
}
